// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d3243597","977":"e8bd13c1"}[chunkId] + ".chunk.js";
};